import IztPreferredTag from './src/izt-preferred-tag'

IztPreferredTag.install = Vue => {
  Vue.component(IztPreferredTag.name, IztPreferredTag)
}

export default IztPreferredTag